import { ScreenBase } from "@frui.ts/screens/dist";
import { interfaces } from "inversify";
import { action, computed } from "mobx";
import LocalizationService from "services/localizationService";
import ChargeDetailResponse from "entities/chargeDetailResponse";
import EmailInputViewModel from "./common/emailInputViewModel";
import { validateAll } from "@frui.ts/validation";
import ChargeManagementService from "../../../services/chargeManagementService";
import EventBus, { sendChargePaymentConfirmationEmailModalClosed } from "services/eventBus";
import InputEmail from "entities/InputEmail";

export default class ReceiptEmailModalViewModel extends ScreenBase {
  public contactViewModel: EmailInputViewModel;

  constructor(
    private charge: ChargeDetailResponse,
    public localizationService: LocalizationService,
    protected emailInputViewModelFactory: ReturnType<typeof EmailInputViewModel.Factory>,
    protected chargeManagementService: ChargeManagementService,
    private eventBus: EventBus,
    public onClose: () => void,
    public onCustomSubmit: () => void
  ) {
    super();
    if (this.charge)
      this.contactViewModel = this.emailInputViewModelFactory(
        new InputEmail(this.charge.emailAddress, this.charge.notificationPreferences._emailConfirmation),
        "",
        ""
      );
  }

  protected onInitialize(): Promise<any> | void {
    return super.onInitialize();
  }

  protected onDeactivate(isClosing: boolean) {
    if (!validateAll([this.charge.emailAddress, this.notificationPreferences])) {
      this.notificationPreferences.emailAddress = undefined;
      this.notificationPreferences._emailConfirmation = "";
    }
    return super.onDeactivate(isClosing);
  }

  @computed
  get code() {
    return this.charge.authCode;
  }

  @computed
  get notificationPreferences() {
    return this.charge.notificationPreferences;
  }

  @computed
  get emailAddress() {
    if (this.charge.emailAddress) return this.charge.emailAddress;
    return "";
  }

  @computed
  get showNotificationPreferences() {
    return false;
  }

  @computed
  get notificationEnabled() {
    return false;
  }

  @computed
  get notificationEnabledInfo() {
    return false;
  }

  @computed
  get isNotificationEmailSame() {
    return false;
  }

  @computed
  get defaultPrefixNumber() {
    return "";
  }

  @action.bound
  get onPhoneNumberChanged() {
    return false;
  }

  @action.bound
  onEmailAddressNotificationChanged(): void {
    //disabled
  }

  @computed
  get description() {
    return this.translate("description")
      .replace("%email%", this.emailAddress)
      .replace("%code%", this.code || "");
  }

  @action.bound
  async onSubmit() {
    if (!validateAll([this.contactViewModel.inputEmail])) {
      return;
    }
    this.charge.emailAddress = this.notificationPreferences.emailAddress = this.contactViewModel.inputEmail.email;
    this.notificationPreferences._emailConfirmation = this.contactViewModel.inputEmail.emailConfirmation;
    this.onCustomSubmit();
    this.onClose();
  }

  @action.bound
  onHide() {
    this.eventBus.publish(sendChargePaymentConfirmationEmailModalClosed());
    this.onClose();
  }

  translate(code: string) {
    return this.localizationService.translateGeneral(`charge.management.edit.receipt.${code}`);
  }

  static Factory({ container }: interfaces.Context) {
    return (charge: ChargeDetailResponse, onClose: () => void, onSubmit: () => void) => {
      return new ReceiptEmailModalViewModel(
        charge,
        container.get(LocalizationService),
        container.get(EmailInputViewModel.Factory),
        container.get(ChargeManagementService),
        container.get(EventBus),
        onClose,
        onSubmit
      );
    };
  }
}
